/**
 * LEAF MODULE: it must have no runtime import. `src/lib/http` (where the HTTP clients are registered at boot) reads the
 * snapshot through `@vnetwork/margarita-shell/iam`; if this file imported anything that calls `getHttpClient(...)` at
 * module level (queries, organization, ...), that call would run BEFORE `registerHttpClient` and the page would stop at
 * boot with HttpClientNotRegisteredError (seen on production, 2026-11-03). Types only, and `tests/organizations/
 * boot-leaf.test.ts` fails if a runtime import is added here.
 */

/** The project a person chose and the organization it belongs to (a project id alone does not say whose it is). */
export interface StoredProject {
  projectId: string;
  organizationId: string;
}

export interface UsableWorkingProject {
  /** The chosen project; while `settled` is false it is the stored choice, not yet checked. */
  project: StoredProject | null;
  /** Both project lists and the home organization are known, so `project` has been checked. */
  settled: boolean;
}

let snapshot: UsableWorkingProject = { project: null, settled: false };

/** The last value `WorkingProjectSync` published, for code that is not a component (the request interceptor). */
export function readUsableWorkingProject(): UsableWorkingProject {
  return snapshot;
}

/** Called by the one component that keeps `readUsableWorkingProject` current. */
export function publishUsableWorkingProject(value: UsableWorkingProject): void {
  snapshot = value;
}
